import { logDiagnostic, normalizeError } from "./index";
import { CODES } from "./contract";
import { redactRuntimeText } from "./redact";

// Global runtime failure capture (ticket #126). Installed ONCE at the app
// entry point (main.tsx) before render. Captures uncaught errors and unhandled
// promise rejections as `runtime` diagnostics with only a normalized error
// name/message and (bounded) stack — never arbitrary error properties.
//
// These handlers preserve normal browser behavior (they don't preventDefault)
// and never re-log the diagnostic delivery path: the transport catches its own
// failures locally, so nothing from delivery reaches window `error` /
// `unhandledrejection`.

let installed = false;

export function installRuntimeDiagnostics(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (e: ErrorEvent) => {
    const norm = e.error
      ? normalizeError(e.error)
      : { errorName: "Error", message: redactRuntimeText(e.message, 500) };
    logDiagnostic({
      level: "error",
      code: CODES.runtime.UNCAUGHT_ERROR,
      category: "runtime",
      message: norm.message,
      details: { errorName: norm.errorName, ...(norm.stack ? { stack: norm.stack } : {}) },
    });
  });

  window.addEventListener("unhandledrejection", (e: PromiseRejectionEvent) => {
    const norm = normalizeError(e.reason);
    logDiagnostic({
      level: "error",
      code: CODES.runtime.UNHANDLED_REJECTION,
      category: "runtime",
      message: norm.message,
      details: { errorName: norm.errorName, ...(norm.stack ? { stack: norm.stack } : {}) },
    });
  });
}
